



































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Menu, MenuItem } from 'element-ui';
import { DEFAULT_AVATAR, NavBar, NavBarWithQuality } from '@/config/map.conf';
import * as api from '@/api';
Vue.use(Menu);
Vue.use(MenuItem);

@Component
export default class TopNav extends Vue {
    @State(state => state.cti.language)
    language: string;

    @State(state => state.cti.env)
    env: string;
    @State(state => state.cti.userInfo)
    userInfo: CommonTypes.UserInfoItem;
    @Prop({ default: DEFAULT_AVATAR, required: false })
    userAvatar: string;
    @Mutation setLanguage;

    @Watch('userAvatar')
    handlerAvatarChange(val) {
        if (val) {
            this.defaultAvatar = val;
        }
    }

    activeIndex: string = 'cti';
    defaultAvatar: string = DEFAULT_AVATAR;
    logoutUrl: string = '/sso/logout';
    imgVisible: boolean = false;
    ticket: string = '';
    navList: any = NavBar;
    // 工作交接
    hasMyHandover: boolean = false;
    hasMemberHandover: boolean = false;
    showChildren: boolean = false;

    get getBaseURL() {
        return this.env === 'prod' ? '//tt.sankuai.com' : this.env === 'test' ? '//tt.cloud.test.sankuai.com' : '//tt.fetc.st.sankuai.com';
    }
    get callBackUrl() {
        if (this.language === 'en') {
            return 'https://tt.sankuai.com/ticket/create?cid=17&tid=4348&iid=37613';
        } else {
            return '//tt.sankuai.com/ticket/create?cid=112&tid=2190&iid=9397';
        }
    }
    get myHandoverUrl() {
        return `${this.getBaseURL}/ticket/my/handover`;
    }
    get memberHandoverUrl() {
        return `${this.getBaseURL}/ticket/member/handover`;
    }

    get getHelpUrl() {
        return this.language === 'en' ? 'https://km.sankuai.com/collabpage/2218074023' : 'https://km.sankuai.com/page/1004881018';
    }

    handleSearch() {
        if (!this.ticket) {
            return;
        }
        window.location.href = `${this.getBaseURL}/ticket/search?name=${this.ticket}`;
    }

    redirectTt() {
        window.location.href = `${this.getBaseURL}`;
    }
    created() {
        this.getHandoverStatus();
        this.getQualityInspectionStatus();
        this.handleLanguage();
    }
    async handleLanguage() {
        /*
         * 和 tt-fe 工程逻辑保持一致
         */
        let newLanguage = '';
        // let newTimeZone = '';
        try {
            // 获取用户时区，提前设置时区信息
            const res = await api.preferenceApi.getUserLanguage();
            const { code, data } = res;
            if (code === 200 && data) {
                newLanguage = data.locale || '';
                // newTimeZone = data.timeZone || '';
            }
        } catch (error) {
            console.error('Get language setting error', error);
        }
        if (!newLanguage) {
            const userLang = navigator.language || navigator.userLanguage;
            if (userLang) {
                const enLangRegex = /^en(-[a-zA-Z]+)?$/;
                if (enLangRegex.test(userLang)) {
                    newLanguage = 'en';
                } else if (userLang === 'zh-HK') {
                    newLanguage = 'zh-HK';
                } else {
                    newLanguage = 'zh';
                }
            }
        }

        // 如果语言和默认语言不一致则替换语言
        if (newLanguage && newLanguage !== this.language) {
            this.$i18nClient.changeLanguage(newLanguage, err => {
                if (err) {
                    this.$mtd.message.error(this.$getText('change_language_failed', '语言切换失败'));
                    return;
                }
                this.setLanguage(newLanguage);
            });
        }
    }
    async getHandoverStatus() {
        const res: any = await api.ctiApi.hasHandover();
        const { code, data } = res;
        if (code === 200 && data) {
            // 如果有两项，展示 工作交接
            this.hasMyHandover = data.myHandover || false;
            this.hasMemberHandover = data.memberHandover || false;
        }
    }
    async getQualityInspectionStatus() {
        // 判断是否展示质检TT
        const res: any = await api.inspectApi.getUserPermission();
        const { code, data } = res;
        if (code === 200 && data) {
            if (data.role && data.role.length) {
                this.navList = NavBarWithQuality;
            }
        }
    }

    getHrefLink(val) {
        let link = '';
        switch (val) {
            case 'handle':
                link = `${this.getBaseURL}/ticket/handle?filter=todo`;
                break;
            case 'filter':
                link = `${this.getBaseURL}/ticket/list?filter=todo`;
                break;
            case 'statistic':
                link = `${this.getBaseURL}/ticket/statistic/new`;
                break;
            case 'cti':
                link = 'javascript:void(0)';
                break;
            case 'quality':
                link = `${this.getBaseURL}/quality/inspection/list`;
                break;
            default:
                break;
        }
        return link;
    }
    get ctiUrl() {
        return this.env === 'prod' ? '//cti.sankuai.com' : '//cti.cloud.test.sankuai.com';
    }
    get menuUserInfo() {
        const targetInfo = {
            mis: this.userInfo.username,
            org: this.userInfo.orgId || ''
        };
        return targetInfo;
    }
    get portalAccess() {
        const whiteList: string[] = ['xiaoqian07', 'zhouxiaobo02', 'liuchen24', 'tanxiaosong'];
        if (this.userInfo.username && whiteList.includes(this.userInfo.username)) {
            return true;
        }
        const groupList: string[] = ['150053', '162994', '40000922', '108635', '1020422', '150858', '114426', '40004401'];
        if (this.userInfo.orgIdPath) {
            const group: string[] = this.userInfo.orgIdPath.split('-');
            const result = group.filter(item => {
                return groupList.indexOf(item) !== -1;
            });
            if (result.length) {
                return true;
            }
        }
        return false;
    }
}
